import { Controller } from "react-hook-form";
import type { UseControllerProps } from "react-hook-form";
import { FloatingLabelInput } from "@ucchub/ui";
import type { TextInputProps } from "@vfuk/core-text-input/dist/TextInput.types";
import type { AccountConfigFormType } from "./AccountConfig.types";

type Props = Pick<
  UseControllerProps<AccountConfigFormType>,
  "control" | "defaultValue" | "rules" | "name"
> & {
  error?: string;
  label: string;
  state?: TextInputProps["state"];
};

const AccountConfigFormInput = ({
  control,
  rules,
  defaultValue,
  name,
  error,
  label,
  state,
}: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => (
        <FloatingLabelInput
          label={label}
          error={error}
          type="text"
          id={name}
          state={state}
          spaceForError={false}
          {...field}
        />
      )}
    />
  );
};

export default AccountConfigFormInput;
